import { useMemo, useState } from 'react'
import * as Resumo from '../../../../../services/api/https/picking/resumo-separcao.http'
import { errorHandler } from '../../../../../services/util/error.service'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_MISSINGS: 'Salvando faltas',
  SAVE_MISSINGS_SUCCESS: 'Faltas salvas com sucesso',
}

const INITIAL_STATE = {
  selectedEntrega: '',
  modal: {
    show: false,
    data: '',
  },
  globalFilter: '',
  codigoProduto: '',
  ocorrencias: {},
  entregas: [],
  entregasOriginais: [],
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useFaltasManualPorIdentificador() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const hasMissingProducts = selectedEntrega => {
      return selectedEntrega.items.filter(i => i.qte_missing_produto > 0).length > 0
    }

    return {
      //Actions
      saveFaltasSeparacaoManual(faltas, picking_id) {
        Resumo.saveFaltasSeparacaoManual(faltas, picking_id)
          .then(files_ids => {
            setState(prevState => {
              const { entregas, selectedEntrega } = prevState
              const index = entregas.findIndex(e => e.identifier === selectedEntrega.identifier)
              if (index !== -1) {
                entregas[index].has_missing_product = hasMissingProducts(selectedEntrega)
                entregas[index].items = entregas[index].items.map(i => {
                  const files = files_ids.filter(f => f.delivery_item_id === i.delivery_item_id)

                  return {
                    ...i,
                    files: files.map(f => ({ id: f.id, url_image: f.url_image })),
                  }
                })
              }

              return {
                ...prevState,
                entregas: entregas,
                loadingMessage: LOAD_MESSAGE.SAVE_MISSINGS_SUCCESS,
                modal: {
                  show: true,
                  data: {
                    items: entregas[index].items,
                    ocorrencias: prevState.modal.data.ocorrencias,
                    selectedEntrega: entregas[index],
                  },
                },
              }
            })
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      getFalta(entregas) {
        const faltas = []
        entregas.forEach(e => {
          const itemsFaltantes = e.items.filter(i => i.qte_missing_produto > 0)
          if (itemsFaltantes.length > 0) {
            itemsFaltantes.forEach(i => {
              const {
                delivery_item_id,
                missing_reason: { id: missing_reason_id },
                qte_missing_produto,
                delivery_step_id,
                files,
              } = i

              let saveFiles = []
              if (files.length && typeof files[0] !== 'string') {
                saveFiles = files.map(f => f.url_image)
              } else saveFiles = files

              faltas.push({
                delivery_item_id,
                missing_reason_id,
                stage: 'Separacao',
                qte_missing: qte_missing_produto * -1,
                delivery_step_id,
                files: saveFiles,
              })
            })
          }
        })

        return faltas
      },

      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      //Events

      onInit(missing_products) {
        setState(prevState => ({
          ...prevState,
          ocorrencias: missing_products.missing_reasons,
          entregas: missing_products.deliveries,
          entregasOriginais: missing_products.deliveries,
          codigoProduto: '',
          globalFilter: '',
        }))
      },

      onMenuItemClicked(entrega) {
        setState(prevState => ({
          ...prevState,
          modal: {
            show: true,
            data: {
              items: entrega.items,
              ocorrencias: prevState.ocorrencias,
              selectedEntrega: entrega,
            },
          },
          selectedEntrega: entrega,
        }))
      },

      onModalClose() {
        setState(prevState => ({ ...prevState, modal: { show: false, data: '' } }))
      },

      onModalSave() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_MISSINGS }))
      },

      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onCodigoProdutoChange(value) {
        setState(prevState => ({ ...prevState, codigoProduto: value }))
      },

      onBuscarPorCodigoProduto() {
        setState(prevState => {
          const codigoProduto = prevState.codigoProduto.trim()

          if (!codigoProduto) {
            return {
              ...prevState,
              errorMessage: 'Informe o Código do Produto antes de buscar',
            }
          }

          return {
            ...prevState,
            entregas: prevState.entregasOriginais.filter(entrega =>
              entrega.items.some(item => String(item.product_code || '').trim() === codigoProduto),
            ),
          }
        })
      },

      onLimparFiltroProduto() {
        setState(prevState => ({
          ...prevState,
          codigoProduto: '',
          globalFilter: '',
          entregas: prevState.entregasOriginais,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
